import CloseIcon from '~shared/assets/icons/close.svg?react';

import { IconButton } from '@breezeventures/ui-kit/icon-button';

import {
  BusinessSelect,
  StatusSelect,
  StoreSelect,
} from './applications-filter-fields';

const FILTER_WIDTH = 'min-w-[180px] flex-1';

type Props = {
  hideMerchantFilter: boolean;
  onFiltersChange: () => void;
  onReset: () => void;
};

export function ApplicationsFilters({
  hideMerchantFilter,
  onFiltersChange,
  onReset,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className={FILTER_WIDTH}>
        <StatusSelect onChange={onFiltersChange} />
      </div>
      {!hideMerchantFilter && (
        <div className={FILTER_WIDTH}>
          <BusinessSelect onChange={onFiltersChange} />
        </div>
      )}
      <div className={FILTER_WIDTH}>
        <StoreSelect onChange={onFiltersChange} />
      </div>
      <IconButton
        type="button"
        variant="secondary"
        size="l"
        aria-label="Reset filters"
        onClick={onReset}
      >
        <CloseIcon className="size-3.5!" />
      </IconButton>
    </div>
  );
}
